

import React from "react";
import { createBrowserRouter } from "react-router-dom";
import {
  UnknowErrorPage,
} from "../pages";
import AppData from "../pages/app/AppData";
import { Paths } from "../common/paths/path";
import { AreaProvider } from "src/context/AreaContext";
import { FilterProvider as ActiveFiltersProvider } from "src/context/ActiveFiltersContext";
import { FilterProvider } from "src/context/FilterContext";
import TrackingPageV2 from "../pages/tracking/TrackingPageV2";
import DashcamPageV2 from "src/pages/dashcam/DashcamPageV2";
import TrafficPageLite from "src/pages/trafficPage/TrafficPageLite";
import EventCenterV2 from "src/pages/eventCenter/EventCenterV2";


const router = createBrowserRouter([
  {
    // Route MyData - Avec tous les contextes nécessaires
    path: `/${Paths.MY_DATA}`,
    element: (
      <AreaProvider>
        <ActiveFiltersProvider>
          <FilterProvider>
            <AppData />
          </FilterProvider>
        </ActiveFiltersProvider>
      </AreaProvider>
    ),
    // errorElement: <ErrorPage />,
    ErrorBoundary: () => <UnknowErrorPage />,
    children: [
      {
        index: true,
        element: <TrafficPageLite />,
      },
      {
        path: "event-center-v2",
        element: <EventCenterV2 />,
      },
      {
        path: "tracking-v2",
        element: <TrackingPageV2 />,
      },
      {
        path: "dashcam-v2",
        element: <DashcamPageV2 />,
      },

    ],
  },

]);

export default router;
